import React, { useEffect, useState } from "react"
import { SectionProps } from "../section-loader"
import {
  ContentWrapper,
  SectionWrapper,
  SectionName,
  NewsWrapper,
  NewContent,
  NewLeftBlock,
  NewRightBlock,
  NewAssetWrapper,
  NewAsset,
  NewTitle,
  NewGameName,
  NewGameDate,
  NewDescription,
  NewLink,
  LoadMoreButton
} from "./vertical-gaming-news-elements"
import { Button, Link } from "../../ui"
import { IAllNews, INews } from "../../../gatsby-graphql"

interface VerticalGamingNewsProps extends SectionProps {
  data: IAllNews
}

const VerticalGamingNews = ({ data, locale }: VerticalGamingNewsProps) => {
  const [loadBundle, setLoadBundle] = useState<INews[]>([])
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);
  const showElements = 3

  useEffect(() => {
    if (data.itemNews && data.itemNews.length > 0) {
      setShowLoadMoreButton(true)
      const currentList: INews[] = []
      for (let i = 0; i < showElements; i++) {
        if (data.itemNews[i]) {
          // @ts-ignore
          currentList.push(data.itemNews[i])
        }
      }
      setLoadBundle([...currentList])
    }
  }, [])

  useEffect(() => {
    if(data.itemNews && loadBundle.length >= data.itemNews.length){
      setShowLoadMoreButton(false);
    }
  }, [loadBundle]);

  const loadMore = () => {
    if (data.itemNews && data.itemNews.length > 0) {
      // @ts-ignore
      setLoadBundle([...data.itemNews])
    }
  }

  return (
    <SectionWrapper>
      <ContentWrapper>
        <SectionName>{data?.title}</SectionName>
        <NewsWrapper>
          {loadBundle.length > 0 ? loadBundle.map((newItem: any, index: number) =>
              <NewContent key={index}>
                <NewLeftBlock>
                  <NewAssetWrapper>
                    <NewAsset src={newItem.asset ? newItem.asset.url : ""} alt={newItem.asset?.name ? newItem.asset?.name : ""} />
                  </NewAssetWrapper>
                </NewLeftBlock>
                <NewRightBlock>
                  <NewTitle>{newItem?.title}</NewTitle>
                  <NewGameName>{newItem?.gameName} <NewGameDate>17.09.2021</NewGameDate></NewGameName>
                  <NewDescription>{newItem?.description}</NewDescription>
                  <NewLink>
                    <Link link={newItem?.readMore?.link} locale={locale}>{newItem?.readMore?.text}</Link>
                  </NewLink>
                </NewRightBlock>
              </NewContent>
            )
            : <> </>}
        </NewsWrapper>
        {showLoadMoreButton ? (<LoadMoreButton>
          <Button type={"transparency"} onClick={() => loadMore()} locale={locale}>Load More</Button>
        </LoadMoreButton>) : (<></>)}
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default VerticalGamingNews
